import { render, staticRenderFns } from "./community_member_list.vue?vue&type=template&id=0db9f2e6&scoped=true&"
import script from "./community_member_list.vue?vue&type=script&lang=js&"
export * from "./community_member_list.vue?vue&type=script&lang=js&"
import style0 from "./community_member_list.vue?vue&type=style&index=0&id=0db9f2e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db9f2e6",
  null
  
)

export default component.exports